(function () {
  const root = document.querySelector('.muster-matrix');
  if (!root) return;

  const moneyFormat = root.getAttribute('data-money-format') || '{{amount}}';

  function formatMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, moneyFormat);
    }
    const value = (cents / 100).toFixed(2).replace('.', ',');
    return value + ' €';
  }

  function recalc() {
    let grand = 0;

    root.querySelectorAll('tr[data-variant-id]').forEach((row) => {
      const price = parseInt(row.getAttribute('data-price-cents') || '0', 10);
      const input = row.querySelector('.muster-matrix__qtyinput');
      const qty = input ? parseInt(input.value || '0', 10) : 0;

      const line = Math.max(0, qty) * price;
      const lineEl = row.querySelector('[data-line-total]');
      if (lineEl) lineEl.textContent = formatMoney(line);

      grand += line;
    });

    const grandEl = root.querySelector('[data-grand-total]');
    if (grandEl) grandEl.textContent = formatMoney(grand);
  }

  function setStatus(msg) {
    const el = root.querySelector('[data-status]');
    if (!el) return;
    el.textContent = msg || '';
  }

  root.addEventListener('click', (e) => {
    const minus = e.target.closest('[data-qty-minus]');
    const plus = e.target.closest('[data-qty-plus]');
    if (!minus && !plus) return;

    const row = e.target.closest('tr[data-variant-id]');
    if (!row) return;

    const input = row.querySelector('.muster-matrix__qtyinput');
    if (!input || input.disabled) return;

    const current = parseInt(input.value || '0', 10);
    const next = plus ? current + 1 : current - 1;
    input.value = String(Math.max(0, next));
    recalc();
  });

  root.addEventListener('input', (e) => {
    if (!e.target.classList.contains('muster-matrix__qtyinput')) return;
    const v = parseInt(e.target.value || '0', 10);
    e.target.value = String(isNaN(v) ? 0 : Math.max(0, v));
    recalc();
  });

  root.querySelector('[data-add-selected]')?.addEventListener('click', async () => {
    setStatus('');

    const items = [];
    root.querySelectorAll('tr[data-variant-id]').forEach((row) => {
      const available = row.getAttribute('data-available') === 'true';
      if (!available) return;

      const variantId = row.getAttribute('data-variant-id');
      const input = row.querySelector('.muster-matrix__qtyinput');
      const qty = input ? parseInt(input.value || '0', 10) : 0;

      if (variantId && qty > 0) items.push({ id: Number(variantId), quantity: qty });
    });

    if (!items.length) {
      setStatus('Bitte wähle mindestens ein Muster mit Menge > 0.');
      return;
    }

    try {
      setStatus('Füge Artikel hinzu …');

      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items })
      });

      if (!res.ok) {
        const txt = await res.text();
        throw new Error(txt || 'Cart add failed');
      }

      window.location.href = '/cart';
    } catch (err) {
      console.error(err);
      setStatus('Fehler beim Hinzufügen. Bitte erneut versuchen.');
    }
  });

  recalc();
})();
